// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import Sidebar from "./Components/SideBar";
// import { SidebarProvider } from "./SidebarContext";
// import AllUsers from "./Components/AllUsers";
// import NewRoom from "./Components/NewRoom";
// import Rooms from "./Components/Rooms";
// import BookedRooms from "./Components/BookedRooms";
// import KeyFeatures from "./Components/KeyFeatures";
// import Amenities from "./Components/Amenities";
// import GuestPreferences from "./Components/GuestPrefrence";
// import ContactTable from "./Components/ContactTable";
// import ReviewTable from "./Components/ReviewTable";
// import GalleryTable from "./Components/Gallery";
// import Login from "./Components/Login";

//             import EditRoom from './Components/RoomEdit';
//             import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";


// const App = () => {
//   return (
//     <SidebarProvider>
//       <div className="app-container">
//         {/* Sidebar is always rendered */}
//         <Sidebar />

//         {/* Main content area */}
//         <div className="main-content">
//           <Routes>

//           <Route path="/login" element={<Login />} />


//             <Route path="/" element={<BookedRooms />} />
//             <Route path="/users" element={<AllUsers />} />
//             <Route path="/new-room-posting" element={<NewRoom />} />
//             <Route path="/rooms" element={<Rooms />} />
//             <Route path="/key-features" element={<KeyFeatures />} />
//             <Route path="/amenities" element={<Amenities />} />
//             <Route path="/guest-preference" element={<GuestPreferences />} />
//             <Route path="/contact-request" element={<ContactTable />} />
//             <Route path="/reviews" element={<ReviewTable />} />
//             <Route path="/gallery" element={<GalleryTable />} />

// <Route path="/edit-room/:id" element={<EditRoom />} />

//           </Routes>
//         </div>
//                 <ToastContainer position="top-right" autoClose={3000} />

//       </div>
//     </SidebarProvider>
//   );
// };

// export default App;




import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./Components/SideBar";
import { SidebarProvider } from "./SidebarContext";
import AllUsers from "./Components/AllUsers";
import NewRoom from "./Components/NewRoom";
import Rooms from "./Components/Rooms";
import BookedRooms from "./Components/BookedRooms";
import KeyFeatures from "./Components/KeyFeatures";
import Amenities from "./Components/Amenities";
import GuestPreferences from "./Components/GuestPrefrence";
import ContactTable from "./Components/ContactTable";
import ReviewTable from "./Components/ReviewTable";
import GalleryTable from "./Components/Gallery";
import Login from "./Components/Login";
import EditRoom from "./Components/RoomEdit";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProtectedRoute from "./Components/ProtectedRoute";
import Reset from "./Components/Reset";   // 👈 new


const App = () => {
  return (
    <SidebarProvider>
      <div className="app-container">
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />
          
          <Route path="/reset" element={<Reset />} />   {/* 👈 Reset page */}

          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <div className="app-layout">
                  <Sidebar />
                  <div className="main-content">
                    <Routes>
                      <Route path="/" element={<BookedRooms />} />
                      <Route path="/users" element={<AllUsers />} />
                      <Route path="/new-room-posting" element={<NewRoom />} />
                      <Route path="/rooms" element={<Rooms />} />
                      <Route path="/key-features" element={<KeyFeatures />} />
                      <Route path="/amenities" element={<Amenities />} />
                      <Route path="/guest-preference" element={<GuestPreferences />} />
                      <Route path="/contact-request" element={<ContactTable />} />
                      <Route path="/reviews" element={<ReviewTable />} />
                      <Route path="/gallery" element={<GalleryTable />} />
                      <Route path="/edit-room/:id" element={<EditRoom />} />
                    </Routes>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>

        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </SidebarProvider>
  );
};

export default App;
